import Axios from 'axios'
import * as React from 'react'
import {AttachmentsViewer} from '../../core/components/Controls/Attachments/AttachmentsViewer2'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {AttachmentInfo, AttachmentInfos} from '../../core/interfaces/models'
import {config} from '../../core/reducers/config'
import {LinearProgress} from '@mui/material'
import {Feature, VectorLayer, LineString, Point} from '../../core/models'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {CsSelector} from '../../core/components/Controls/CsSelector'
import {getMapService} from '../../core/reducers/map'
import appConfig from '../../reducers/appConfig'

interface Props {}

interface CadLine {
  Layer: string
  Geometry: {
    Coordinates: {X: number; Y: number}[]
  }
}

interface CadText {
  Text: string
  Type: string
  Geometry: {X: number; Y: number}
}

interface CadContour {
  Name: string
  Type: string
  Lines: number[]
  Centroid: {X: number; Y: number}
}

interface Status {
  lines: CadLine[]
  contours: CadContour[]
  texts: CadText[]
}

interface State {
  loading: boolean
  file?: AttachmentInfo
  dataCS: CoordinateSystem
  afterSuccess: boolean
  error: string
  progress: number
  status: Status
  COORDTYPE: string
}

export class Cad4Preview extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      afterSuccess: false,
      loading: false,
      dataCS: CoordinateSystem.BG2005CAD,
      error: '',
      progress: 0,
      status: {lines: [], contours: [], texts: []},
      COORDTYPE: ''
    }
  }

  getProjectionSelector = (): JSX.Element => {
    return (
      <CsSelector
        selected={this.state.dataCS}
        onChange={s => this.setState({...this.state, error: '', dataCS: s})}
        className="form-control"
      />
    )
  }

  public statusMap = new Map<number, string>()

  getAttachmentsControl = () => {
    const adds: AttachmentInfos = {}
    if (this.state.file) {
      adds[this.state.file.name] = this.state.file
      this.state.file.file
        ?.slice(100, 500)
        .text()
        .then((text: string) => {
          const COORDTYPE = text.match(/COORDTYPE\s+(\w+)/)
          if (COORDTYPE) {
            this.setState({...this.state, COORDTYPE: COORDTYPE[1]})
          }
        })
    }

    return (
      <div style={{margin: '5px'}}>
        <AttachmentsViewer
          attachments={{}}
          deletes={{}}
          updates={{}}
          adds={adds}
          acceptTypes={'.cad,.CAD'}
          maxNumber={1}
          onAttachmentsChange={changes => {
            const addedFiles = Object.keys(changes.adds)
            let file: AttachmentInfo | undefined
            if (addedFiles.length > 0) {
              file = changes.adds[addedFiles[0]]
            }
            this.setState({...this.state, file: file, error: ''})
          }}
          feature={new Feature({})}
          uploadToArchive={false}
        ></AttachmentsViewer>
      </div>
    )
  }
  getContainer = (content: JSX.Element, title: string | JSX.Element, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>
        {content}
      </div>
    )
  }

  latestFeat: Feature | undefined = undefined

  getExecuteButton = () => {
    return (
      <button
        type="button"
        className="button width"
        disabled={!this.state.file}
        onClick={() => {
          const formData = new FormData()
          formData.append('File', this.state.file!.file!, this.state.file!.name)
          formData.append('DataCS', this.state.dataCS)
          this.setState({...this.state, loading: true}, () => {
            Axios.post(config.getConfig().urls.xyApiUrl + '/cad-preview', formData, {
              headers: {'Content-Type': `multipart/form-data;`},
              onUploadProgress: progressEvent => {
                const progress = progressEvent.total ? (progressEvent.loaded / progressEvent.total) * 100 : 0
                this.setState({...this.state, progress: progress})
              }
            })
              .then(r => {
                this.setState({...this.state, afterSuccess: true, error: '', loading: false, status: r.data})
              })
              .catch(error => {
                if (error.response && error.response.data && error.response.data) {
                  this.setState({...this.state, error: error.response.data})
                } else {
                  this.setState({...this.state, error: 'Възникна грешка ' + error.message, loading: false})
                }
              })
          })
        }}
      >
        Зареди на картата
      </button>
    )
  }
  afterSuccess() {
    const cadPreviewLine = getMapService()
      .getLayers()
      .find(l => l.moreInfo.urls.indexOf(appConfig.reg.cadPreviewLine.url) != -1)! as VectorLayer

    const cadPreviewContur = getMapService()
      .getLayers()
      .find(l => l.moreInfo.urls.indexOf(appConfig.reg.cadPreviewContur.url) != -1)! as VectorLayer

    const cadPreviewText = getMapService()
      .getLayers()
      .find(l => l.moreInfo.urls.indexOf(appConfig.reg.cadPreviewText.url) != -1)! as VectorLayer

    if (this.state.status['lines'].length > 0) {
      const x = this.state.status['lines'][0]['Geometry']['Coordinates'][0]['X']
      const y = this.state.status['lines'][0]['Geometry']['Coordinates'][0]['Y']
      getMapService().setCenter([x, y])

      const layerlist = []

      for (let i = 0; i < this.state.status['lines'].length; i++) {
        this.latestFeat = new Feature()
        this.latestFeat.set('Layer', this.state.status['lines'][i]['Layer'])
        const lineItems: [number, number][] = []

        this.state.status['lines'][i]['Geometry']['Coordinates'].forEach((element: any) => {
          lineItems.push([element.X, element.Y])
        })

        if (layerlist.indexOf(this.state.status['lines'][i]['Layer']) == -1) {
          layerlist.push(this.state.status['lines'][i]['Layer'])
        }
        const line = new LineString(lineItems)
        this.latestFeat.setGeometry(line)
        cadPreviewLine.getSource().addFeature(this.latestFeat)
      }

      for (let i = 0; i < this.state.status['contours'].length; i++) {
        this.latestFeat = new Feature()
        this.latestFeat.set('Name', this.state.status['contours'][i]['Name'])
        this.latestFeat.set('Type', this.state.status['contours'][i]['Type'])
        this.latestFeat.set('Centroid', this.state.status['contours'][i]['Centroid'])

        this.latestFeat.setGeometry(
          new Point([
            this.state.status['contours'][i]['Centroid']['X'],
            this.state.status['contours'][i]['Centroid']['Y']
          ])
        )
        cadPreviewContur.getSource().addFeature(this.latestFeat)
      }
      for (let i = 0; i < this.state.status['texts'].length; i++) {
        this.latestFeat = new Feature()
        this.latestFeat.set('Text', this.state.status['texts'][i]['Text'])
        this.latestFeat.set('Type', this.state.status['texts'][i]['Type'])
        this.latestFeat.setGeometry(
          new Point([this.state.status['texts'][i]['Geometry']['X'], this.state.status['texts'][i]['Geometry']['Y']])
        )
        cadPreviewText.getSource().addFeature(this.latestFeat)
      }
    }

    return (
      <div>
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({...this.state, afterSuccess: false, file: undefined})
          }}
        >
          Виж друг фаил
        </button>
      </div>
    )
  }

  onerror() {
    return (
      <div className="error-div">
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({...this.state, afterSuccess: false, file: undefined, error: ''})
          }}
        >
          Виж друг фаил
        </button>
        {this.state.error}
      </div>
    )
  }

  render() {
    return (
      <div style={{padding: '10px', boxSizing: 'border-box', height: '80%', overflow: 'auto'} as React.CSSProperties}>
        {this.state.afterSuccess ? (
          this.afterSuccess()
        ) : this.state.error ? (
          this.onerror()
        ) : (
          <div style={{position: 'relative'}}>
            <OverlayLoader show={this.state.loading}></OverlayLoader>

            {this.getContainer(this.getAttachmentsControl(), 'Прикачете файл', `10px 0px`)}
            {this.getContainer(this.getProjectionSelector(), 'Координатна система на данните от файла', `10px 0px`)}
            {this.state.file ? (
              <div style={{marginTop: '5px'}}>Вероятна координатна система на файла: {this.state.COORDTYPE}</div>
            ) : null}
            {this.getExecuteButton()}
            {this.state.loading ? <LinearProgress variant="determinate" value={this.state.progress} /> : null}
          </div>
        )}
      </div>
    )
  }
}
